import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.unshift.js";
import textRegs from './textRegs'; // 是否为已设置的数字

const isNumber = val => {
  return val !== '' && val !== null && !isNaN(val);
};

const regNameMap = textRegs.reduce((ret, item) => ({ ...ret,
  [item.value]: [item.label]
}), {});
const regTypeMap = textRegs.reduce((ret, item) => ({ ...ret,
  [item.type]: item.value
}), {});
const rules = {
  min(val, options) {
    const {
      label,
      min
    } = options;
    return isNumber(min) && isNumber(val) && val < min ? `${label}不能小于${min}` : '';
  },

  max(val, options) {
    const {
      label,
      max
    } = options;
    return isNumber(max) && isNumber(val) && val > max ? `${label}不能大于${max}` : '';
  },

  minLength(val, options) {
    const {
      label,
      minLength
    } = options;

    if (!val || !minLength) {
      return '';
    }

    return val.length < minLength ? `${label}长度不能小于${minLength}` : '';
  },

  maxLength(val, options) {
    const {
      label,
      maxLength
    } = options;

    if (!val || !maxLength) {
      return '';
    }

    return val.length > maxLength ? `${label}长度不能大于${maxLength}` : '';
  }

};
const rulesKeys = Object.keys(rules); // 从 schema 定义中读取校验规则

export const getRules = (schema, factory, {
  trigger = 'blur',
  value = {}
} = {}) => {
  console.log(value, 'value');

  if (!schema || !schema.children) {
    return null;
  }

  return schema.children.reduce((ret, element) => {
    const {
      xtype
    } = element;
    const options = factory.getControl(xtype);

    if (!options) {
      return ret;
    }

    const elemConfig = element.options || {};
    const key = element.key || elemConfig.name;
    let {
      regex,
      regName
    } = elemConfig;
    const checkers = [];

    if (regName) {
      regex = regTypeMap[regName] || regex;
    } // 正则校验


    if (regex) {
      checkers.push(value => {
        const success = new RegExp(regex).test(value);

        if (success) {
          return '';
        }

        const regName = regNameMap[regex];
        return regName ? `输入文本必须为${regName}` : '不满足正则校验要求';
      });
    } // 校验型属性校验


    rulesKeys.forEach(key => {
      if (key in elemConfig) {
        checkers.push(value => {
          return rules[key].call(null, value, elemConfig);
        });
      }
    }); // 自定义校验

    if (options.meta && options.meta.validate) {
      checkers.push(value => options.meta.validate(value, elemConfig));
    }

    if (checkers.length > 0) {
      const validRule = {
        validator: (rule, value, callback) => {
          if (!callback) {
            value = rule;
          }

          for (let i = 0; i < checkers.length; i++) {
            const err = checkers[i](value);

            if (err) {
              // 兼容 vant 校验模块
              validRule.message = err;
              return callback ? callback(new Error(err)) : false;
            }
          }

          return callback ? callback() : true;
        },
        trigger
      };
      ret[key] = [validRule];
    }

    if (elemConfig.required) {
      const required = elemConfig.required;
      ret[key] = ret[key] || [];

      if (typeof required === 'boolean') {
        ret[key].unshift({
          required: true,
          message: `${elemConfig.label}必须填写`,
          trigger
        });
      }
    }

    return ret;
  }, {});
};